import { TextField as MUITextField, TextFieldProps } from "@mui/material";
import { commonStyles } from "./commonStyles";

interface CustomTextFieldProps extends Omit<TextFieldProps, "variant"> {
  error?: boolean;
  helperText?: React.ReactNode;
}

const TextField = ({ error, helperText, ...props }: CustomTextFieldProps) => {
  return (
    <MUITextField
      error={error}
      helperText={helperText}
      variant="outlined"
      slotProps={{
        input: {
          notched: false,
        },
      }}
      sx={{
        "& .MuiFormLabel-root": {
          position: "static",
          transform: "none",
          fontSize: commonStyles.fontSizes.medium,
          color: "black",
          mb: 0.2,
          ml: 0.5,
          fontWeight: "bold",
          "&.Mui-focused": {
            color: "black",
          },
          "&.Mui-error": {
            color: "black",
          },
        },
        "& .MuiOutlinedInput-root": {
          backgroundColor: "white",
          borderRadius: 3,
          "& fieldset": {
            borderColor: "#B0B5BC",
          },
          "&:hover fieldset": {
            borderColor: "#B0B5BC",
          },
          "&.Mui-focused fieldset": {
            borderWidth: 1,
            borderColor: commonStyles.cpaGold,
          },
          "&.Mui-error fieldset": {
            borderColor: commonStyles.errorRed,
          },
        },
        "& .MuiInputBase-input": {
          fontSize: commonStyles.fontSizes.medium,
          "&::placeholder": {
            color: "#9CA3AF",
            opacity: 1,
          },
        },
        "& .MuiFormHelperText-root": {
          marginLeft: "4px",
          fontSize: commonStyles.fontSizes.small,
          position: "absolute",
          bottom: "-24px",
        },
      }}
      {...props}
    />
  );
};

export default TextField;
